/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Secondary_School_Teaching30Inputs */

const en__field__enum_primarystudyinterest_study_secondary_school_teaching30 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Secondary_School_Teaching30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary School Teaching`)
};

const de__field__enum_primarystudyinterest_study_secondary_school_teaching30 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Secondary_School_Teaching30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Gymnasien`)
};

/**
* | output |
* | --- |
* | "Secondary School Teaching" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Secondary_School_Teaching30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_secondary_school_teaching30 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Secondary_School_Teaching30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Secondary_School_Teaching30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_secondary_school_teaching30(inputs)
	return de__field__enum_primarystudyinterest_study_secondary_school_teaching30(inputs)
});
export { _field__enum_primarystudyinterest_study_secondary_school_teaching30 as "_field__enum_primaryStudyInterest_STUDY_SECONDARY_SCHOOL_TEACHING" }